import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { EnvService } from './env.service';
import { CallBackTransformService } from './call-back-transform.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { localStorageConstants } from '../localStorageConstants/localStorageConstants';

@Injectable({
  providedIn: 'root'
})
export class HelperListService {

  constructor(
    private envService: EnvService,
    private http: HttpClient,
    private callBackTransformService: CallBackTransformService,
    private localStorageService: LocalStorageService
  ) { }

  /**
 * helper list
 * @param Object peopleInfo
 * @return Object Resultset
 */
  helperList(helperObj,isDashboardView?): Observable<any> {
    let headers = new HttpHeaders();
    if(isDashboardView){
       headers = new HttpHeaders().set('ignoreProgressBar', "");
    }
    const options = { headers: headers };
    const url = this.envService.apiUrl + 'helpers/list';
    return this.http.post<any>(url, helperObj,options).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * Settings helper list - new API for helper table in settings
   * @param Object helperObj
   * @return Object Resultset
   */
  settingsHelperList(helperObj): Observable<any> {
    const url = this.envService.apiUrl + 'settings-helpers/list';
    return this.http.post<any>(url, helperObj).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
  /**
 * helper list
 */
  helperAllList(userId, pageNo, pageSize): Observable<any> {
    const url = this.envService.apiUrl + 'helpers/' + userId + '/' + pageNo + '/' + pageSize;
    return this.http.get(url).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
* save Helper
* @param Object peopleInfo
* @return Object Resultset
*/
  saveHelper(helperInfo): Observable<any> {
    const url = this.envService.mockUrl + 'add-people';
    return this.http.post<any>(url, helperInfo);
  }

  /**
 * getHelperDetails by Index
 * @param Object peopleInfo
 * @return Object Resultset
 */
  getHelperDetailsByIndex(index): Observable<any> {
    const url = this.envService.apiUrl + 'helper/' + index;
    return this.http.get<any>(url).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
  deleteHelperdata(helperIndex): Observable<any> {
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.collaborationLeads);
    const url = this.envService.apiUrl + 'helper/' + helperIndex;
    return this.http.delete(url, helperIndex).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
  updateHelperDetails(helperObj): Observable<any> {
    const config = { headers: { fileFlag: 'true' } };
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.collaborationLeads);
    const url = this.envService.apiUrl + 'helper';
    return this.http.put(url, helperObj,config).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
    * Api to retreve userDetails
    */
  getUserDetails(): Observable<any> {
    const userDetails = this.localStorageService.getFromLocalStorage(localStorageConstants.userDetails);
    if (userDetails == null || userDetails.length === 0) {
      const url = this.envService.apiUrl + 'helper/userdetails';
      return this.http.get<any>(url).pipe(
        map((data) => {
          this.localStorageService.saveInLocalStorage(localStorageConstants.userDetails,
            JSON.stringify(this.callBackTransformService.transformOutput(data)));
          return this.callBackTransformService.transformOutput(data);
        }),
        catchError((error) => {
          return throwError(this.callBackTransformService.transformOutput(error));
        })
      );
    } else {
      const result = new Observable((observer) => {
        observer?.next(userDetails);
      });
      return result;
    }
  }

  reInviteHelper(helperIndex): Observable<any> {
    const url = this.envService.apiUrl + 'helpers/resendhelperinvitation/' + helperIndex;
    return this.http.put(url, {}).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
  saveHelperId(helperObj: any) {
    const url = this.envService.apiUrl + 'save-default-helperid';
    return this.http.post<any>(url, helperObj).pipe(
      map((output) => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
  getDefaultHelperDetails(agencySharingId){
    const url = this.envService.apiUrl + 'default-helper-details/' + agencySharingId;
    return this.http.get<any>(url).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
  getBase64StringFromURL(param): Observable<any> {
    const encodedFileUrl = encodeURIComponent(param);
    const url = this.envService.apiUrl + 'downloadBlobFiles?fileUrl=' + encodedFileUrl;
    return this.http.get<any>(url).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * Validate helper end date eligibility
   * @param helperIndex Helper index to check
   * @returns Observable with eligibility status
   */
  validateHelperEndDateEligibility(helperIndex: string): Observable<any> {
    const url = this.envService.apiUrl + 'helper/validate-enddate-eligibility/' + helperIndex;
    return this.http.get(url, {}).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
}
